<div mat-dialog-content>
<h1>{{data.message}}</h1>
  <h3>{{data.messageSecondary}}</h3>
    <div>
        <div class="mt-3">
        <label style="width: 100px">Unique Link</label>
        <div>
          <span>{{data.uniqueLink}}&emsp;</span>
          <button mat-icon-button aria-label="Copy unique link" [cdkCopyToClipboard]="data.uniqueLink">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>
      <div class="mt-2">
        <label style="width: 100px">Unique Code</label>
        <div>
          <span>{{data.uniqueCode}}&emsp;</span>
          <button mat-icon-button aria-label="Copy unique code" [cdkCopyToClipboard]="data.uniqueCode!">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="center">
    <ng-container *ngIf="data.showViewApplicationButton">
      <button mat-button [mat-dialog-close]="data.sessionId" (click)="onView()" color="primary" cdkFocusInitial>View</button>
    </ng-container>
  <button mat-button mat-dialog-close (click)="onDismiss()">Dismiss</button>
</div>
